<template>
  <div class="exhibitorBrief">
    <div class="header">
      <div class="service_h">企业简介</div>
    </div>
    <div class="c1" v-html="bierfInfo.cIntroduction"></div>
    <!-- <div class="c2"></div> -->
    <div class="c3">
      <div class="tabDiv">
        <div class="tabD1">公司名称</div>
        <div class="tabD2">{{ bierfInfo.cName }}</div>
        <div class="tabD1">企业性质</div>
        <div class="tabD2">{{ bierfInfo.cType }}</div>
      </div>
      <div class="tabDiv">
        <div class="tabD1">联系人</div>
        <div class="tabD2">{{ bierfInfo.pName }}</div>
        <div class="tabD1">注册时间</div>
        <div class="tabD2">{{ bierfInfo.cYear }}</div>
      </div>
      <div class="tabDiv">
        <div class="tabD1">联系邮箱</div>
        <div class="tabD2">{{ bierfInfo.pEmail }}</div>
        <div class="tabD1">注册资金</div>
        <div class="tabD2">{{ bierfInfo.cManey }}</div>
      </div>
      <div class="tabDiv">
        <div class="tabD1">联系电话</div>
        <div class="tabD2">{{ bierfInfo.mobile }}</div>
        <div class="tabD1">公司网址</div>
        <div class="tabD2">{{ bierfInfo.cWebsite }}</div>
      </div>
	  <div class="tabDiv">
	    <div class="tabD1">企业类型</div>
	    <div class="tabD2">{{ bierfInfo.cType }}</div>
	    <div class="tabD1">运作模式</div>
	    <div class="tabD2">{{ bierfInfo.cRun }}</div>
	  </div>
	  <div class="tabDiv">
	    <div class="tabD3">所属地区</div>
	    <div class="tabD4">{{ bierfInfo.cAddress }}</div>
	  </div>
	  <div class="tabDiv">
	    <div class="tabD3">详细地址</div>
	    <div class="tabD4">{{ bierfInfo.cAddress }}</div>
	  </div>
      <div class="tabDiv">
        <div class="tabD3">主营产品</div>
        <div class="tabD4">{{ bierfInfo.ProductVo }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["exhibitorId"],
  data() {
    return {
      bierfInfo: {
        cIntroduction: "",
        cName: "",
        cType: "",
        pName: "",
        pEmail: "",
        mobile: "",
        cWebsite: "",
        ProductVo: "",
        cYear: "",
        CManey: "",
        cAddress: "",
        cRun: "",
      },
    };
  },
  mounted() {
    let sessionAccountId = sessionStorage.getItem("accountId");
    this.getBierf(sessionAccountId);
  },
  methods: {
    getBierf(id) {
      this.$http({
        url: "getAccountIndex",
        method: "post",
        params: {
          accountId: id,
        },
      }).then(({ data }) => {
        let { code, user } = data;
        if (code === 0) {
          this.bierfInfo.cIntroduction = user.cIntroduction;
          this.bierfInfo.cName = user.cName;
          this.bierfInfo.cType = user.cType;
          this.bierfInfo.pName = user.pName;
          this.bierfInfo.pEmail = user.pEmail;
          this.bierfInfo.mobile = user.mobile;
          this.bierfInfo.cWebsite = user.cWebsite;
          this.bierfInfo.ProductVo = user.ProductVo;
          this.bierfInfo.cYear = user.cYear;
          this.bierfInfo.cManey = user.cManey;
          this.bierfInfo.cAddress = user.cAddress;
          this.bierfInfo.cRun = user.cRun;
        }
      });
    },
  },
};
</script>>
<style lang="scss" scoped>
.exhibitorBrief {
  width: 100%;
  height: 1161px;
  background-color: #ffffff;
  color: #333333;
  .header {
    width: 100%;
    height: 30px;
    line-height: 35px;
    margin-bottom: 40px;
    .service_h {
      width: 100px;
      height: 100%;
      float: left;
      font-size: 16px;
      color: #143372;
      border-top: 2px solid #143372;
      border-right: 1px solid #bbbbbb;
      text-align: center;
    }
  }
  .c1,
  .c2 {
    padding: 0 40px;
  }
  .c1,
  .c2 {
    min-height: 75px;
    line-height: 30px;
    font-size: 14px;
    text-indent: 29px;
    margin-bottom: 50px;
  }
  .c3 {
    width: 798px;
    // height: 386px;
    border: 1px solid #d6d6d6;
    margin: 0 auto;
    .tabDiv {
      width: 100%;
      height: 48px;
      border-bottom: 1px solid #d6d6d6;
      font-size: 14px;
      color: #333333;
      line-height: 48px;
	  overflow: hidden;
      .tabD1,
      .tabD2,
      .tabD3,
      .tabD4 {
        float: left;
      }
      .tabD1,
      .tabD3 {
        width: 162px;
        height: 100%;
        background-color: #f5f5f5;
        border-right: 1px solid #d6d6d6;
        text-align: center;
      }
      .tabD4 {
        width: 635px;
        height: 100%;
        text-indent: 20px;
      }
      .tabD2 {
        width: 235px;
        // height: 100%;
        border-right: 1px solid #d6d6d6;
        text-indent: 20px;
        overflow: hidden;
      }
      .tabD2:last-child {
        border-right: none;
      }
      .cAddress {
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: column;
        text-indent: 0;
        p {
          line-height: 18px;
          padding: 6px 0 0 20px;
        }
      }
    }
    .tabDiv:last-child {
      height: 92px;
      border-bottom: none;
      line-height: 92px;
    }
  }
}
</style>